<template>
  <div class="main-card card col-12 mb-5">
    <div class="no-gutters row">
      <template v-for="(statusObject, status, index) in listStatus" :key="status">
        <div v-if="totalSale[`status_${status}`]" class="col-12 col-md-6 col-lg-3">
          <div class="widget-content">
            <div class="widget-content-wrapper">
              <div class="widget-content-left">
                <div class="widget-heading">{{ statusObject.label }}</div>
                <div class="widget-subheading" style="cursor: default">
                  <small class="d-block">
                    <span class="has-tip" data-title="Sale Price" v-html="getPrices(totalSale[`status_${status}`].sale_price)"></span>
                  </small>
                  <small class="d-block">
                    <span class="has-tip" data-title="Purchase Price" v-html="getPrices(totalSale[`status_${status}`].purchase_price)"></span>
                  </small>
                </div>
              </div>
              <div class="widget-content-right">
                <div :class="`widget-numbers ${styles[index % styles.length].text}`">
                  {{ statusNumber(totalSale[`status_${status}`]) }}
                </div>
              </div>
            </div>
            <div class="widget-progress-wrapper">
              <div class="progress-bar-sm progress-bar-animated-alt progress">
                <div :class="`progress-bar ${styles[index % styles.length].progressbar}`" :style="`width:${statusPercent(totalSale[`status_${status}`])}%`"></div>
              </div>
              <div class="progress-sub-label">
                <div class="sub-label-left">0%</div>
                <div class="sub-label-right">100%</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      total: null,
      styles: [
        {
          text: 'text-warning',
          progressbar: 'bg-warning'
        },
        {
          text: 'text-danger',
          progressbar: 'bg-danger'
        },
        {
          text: 'text-primary',
          progressbar: 'bg-primary'
        },
        {
          text: 'text-success',
          progressbar: 'bg-success'
        }
      ]
    }
  },
  computed: {
    data() {
      return this.config
    },
    currency() {
      let currency = Object.assign({}, this.data?.currency || {})
      currency.purchase = Object.assign({}, currency?.purchase || {}, {
        '': {
          label: ''
        }
      })
      return currency
    },
    listStatus() {
      return Object.fromEntries(
        Object.entries(Object.assign({}, this.data.status)).sort(([, a], [, b]) => {
          return (a.priority || 10) - (b.priority || 10)
        })
      )
    },
    totalSale() {
      return Object.assign({}, this.data.total_sale || {})
    }
  },
  methods: {
    statusNumber(item) {
      return item.number || 0
    },
    statusPercent(item) {
      return Math.round((this.statusNumber(item) * 100) / this.statusNumber(this.totalSale.status_total))
    },
    getPrices(items) {
      let prices = []
      if (_.isObjectLike(items)) {
        Object.entries(items).forEach(([currency, price]) => {
          if (price > 0) {
            prices.push(`${parseFloat(price).toFixed(2)}${this.currency.sale[currency] != undefined ? this.currency.sale[currency].label : currency}`)
          }
        })
      }
      return prices.join(' - ')
    }
  },
  props: {
    config: Object
  }
}
</script>
